<div class="benchmark-data-source-info-dialog">
    <div class="header">
        <div class="header-title">
            <i class="fa-solid fa-info-circle"></i>
            <h1 class="text-12-regular color-text-primary">
                De onde vêm os dados?
            </h1>
        </div>
        <dsn-button-menu-chips
            [mainIcon]="'fa-solid fa-xmark'"
            size="medium"
            (onClick)="this.dialogRef.close()"
        ></dsn-button-menu-chips>
    </div>
    <div class="content">
        <p class="text-12-regular color-text-primary">
            Os dados de benchmarking são obtidos a partir de uma comparação
            entre a <b>sua empresa e outras do mesmo segmento e porte</b>,
            presentes na base de dados da Nucont.
        </p>
    </div>
</div>
